import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface WaitingRoomReasonData {
    title?: string;
    message?: string;
}

export interface WaitingRoomReasonResult {
    reason: string;
    reasonText?: string;
}

export const WAITING_ROOM_REASONS = {
    INCORRECT_SCRIPT: 'Incorrect Script',
    INCORRECT_MED_CERT: 'Incorrect Med Cert',
    SCRIPT_NOT_ISSUED: 'Script not issued',
    MED_CERT_NOT_ISSUED: 'Med Cert not issued',
    INCORRECT_ADVICE: 'Incorrect Advice',
    OTHER: 'Other'
} as const;

@Component({
    selector: 'app-dialog-waiting-room-reason',
    templateUrl: './dialog-waiting-room-reason.component.html',
    styleUrls: ['./dialog-waiting-room-reason.component.scss'],
    standalone: false
})
export class DialogWaitingRoomReasonComponent {
    selectedReason: string | null = null;
    otherReasonText = '';
    showOtherTextArea = false;

    readonly reasons = [
        WAITING_ROOM_REASONS.INCORRECT_SCRIPT,
        WAITING_ROOM_REASONS.INCORRECT_MED_CERT,
        WAITING_ROOM_REASONS.SCRIPT_NOT_ISSUED,
        WAITING_ROOM_REASONS.MED_CERT_NOT_ISSUED,
        WAITING_ROOM_REASONS.INCORRECT_ADVICE,
        WAITING_ROOM_REASONS.OTHER
    ];

    constructor(
        public dialogRef: MatDialogRef<DialogWaitingRoomReasonComponent>,
        @Inject(MAT_DIALOG_DATA) public data: WaitingRoomReasonData
    ) { }

    onReasonSelection(reason: string) {
        this.selectedReason = reason;
        this.showOtherTextArea = reason === WAITING_ROOM_REASONS.OTHER;
        if (!this.showOtherTextArea) {
            this.otherReasonText = '';
        }
    }

    onSubmit() {
        if (!this.canSubmit()) {
            return;
        }

        const result: WaitingRoomReasonResult = {
            reason: this.selectedReason!,
            reasonText: this.showOtherTextArea ? this.otherReasonText.trim() : undefined
        };

        this.dialogRef.close(result);
    }

    onCancel() {
        this.dialogRef.close(null);
    }

    canSubmit(): boolean {
        if (!this.selectedReason) {
            return false;
        }
        if (this.showOtherTextArea) {
            return this.otherReasonText.trim().length > 0;
        }
        return true;
    }
}
